import { get, post, put } from '../lib/apiClient';

/** Investment member services (docs/Decisions.md D66). */
export const getMemberServices = () => get('/billing/member-services');

export const saveMemberService = (serviceId, data) =>
  put(`/billing/member-services/${encodeURIComponent(serviceId)}`, data);

/** `query`: { scope: 'mine' | 'org' | 'platform', status?, cursor? } */
export const listServiceRequests = query => get('/billing/member-services/requests', { query });

export const createServiceRequest = (serviceId, details) =>
  post('/billing/member-services/requests', { serviceId, details });

export const actOnServiceRequest = (requestId, action, note) =>
  post(`/billing/member-services/requests/${encodeURIComponent(requestId)}/actions`, {
    action,
    ...(note ? { note } : {}),
  });
